module.exports = __webpack_public_path__ + "img/pro_dg.fbd7243b.png";